import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'number',
})
export class NumberPipe implements PipeTransform {
  transform(value: any, decimalPlaces?, rounded: boolean = false): any {
    let originalVal = value;

    if (value !== undefined && /^[-+]?\d+\.?\d*$/.test(value)) {
      let parts = value.toString().split('.');

      if (!rounded) {
        if (!decimalPlaces) {
          return parts[0].replace(/\B(?=(\d{3})+(?=$))/g, ',') + (parts[1] ? '.' + parts[1] : '');
        } else {
          let roundOffVal = (Math.round(value * 100) / 100).toFixed(decimalPlaces);
          parts = roundOffVal.toString().split('.');
          return parts[0].replace(/\B(?=(\d{3})+(?=$))/g, ',') + (parts[1] ? '.' + parts[1] : '');
        }
      } else {
        let stringNum = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
        let stringNumParts = stringNum.toString().split('.');
        let decimalPart = (stringNumParts[1] && stringNumParts[1].toString().padEnd(decimalPlaces, '0')) || '0'.padEnd(decimalPlaces, '0');
        return stringNumParts[0].replace(/\B(?=(\d{3})+(?=$))/g, ',') + (decimalPart ? '.' + decimalPart : '');
      }
    } else if (!value || value === 'Infinity' || value === '-Infinity' || value === 'null' || value === 'NaN') {
      originalVal = 'N/A';
    }

    return originalVal;
  }
}
